(function () {
  

  document.addEventListener('click', function (e) {
    if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey || e.button !== 0) return;

    const title = e.target.closest('a[data-essential-upsell-element="title"]');
    if (title) return; // native link, let the browser handle it

    const imgBox = e.target.closest('[data-essential-upsell-element="image-container"]');
    
    if (!imgBox) return;

    const product = imgBox.closest('[data-essential-upsell-element="product"]');
    const link = product && product.querySelector('a[data-essential-upsell-element="title"]');
    if (link && link.href) {
      
      e.preventDefault();
      window.location.href = link.href;
    }
  }, true);

  const applyCursor = (root) => {
    if (!root.querySelectorAll) return;
    root.querySelectorAll('[data-essential-upsell-element="image-container"]')
      .forEach((el) => (el.style.cursor = 'pointer'));
  };
  applyCursor(document);
  new MutationObserver((muts) => {
    for (const m of muts) for (const n of m.addedNodes) if (n.nodeType === 1) applyCursor(n);
  }).observe(document.documentElement, { childList: true, subtree: true });
})();